import React from "react";
import useAccess from "./useAccess";

interface IShowFeatureFlagProps {
  flag: string;
  orWhen?: any;
  fallback?: any;
  children?: any;
}

// Shows children when the user's company has the feature flag, or when the
// user has the `orWhen` permission (so internal teams keep access).
const ShowFeatureFlag = ({
  flag,
  orWhen,
  fallback = null,
  children,
  ...rest
}: IShowFeatureFlagProps) => {
  const { hasFeatureFlag, hasPermission } = useAccess();

  const show = hasFeatureFlag(flag) || (!!orWhen && hasPermission(orWhen));

  if (!show) {
    return fallback;
  }

  return React.Children.map(children, (child) =>
    React.cloneElement(child, rest),
  );
};

export default ShowFeatureFlag;
